import { Injectable } from "@angular/core";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { User } from "../domain/user";

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/document`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    generateCalendarExport(date: string, userList: User[]) {
        this.loadingTask.activateLoading();
        let params = new HttpParams();
        userList.forEach(u => {
            params = params.append('sampler', `${u.Puid}`);
        })
        return this.http.get(`${this.serviceUrl}/export/suiviLabo/${date}`, this.generateHeaderForBlobDownloadWithParameter(params)).pipe(
            catchError(this.handleError<any>('generateCalendarExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}